import * as $ from 'jquery';
import { disposableSubscription } from 'common/barrels/core';
import { BehaviorSubject, Observable } from 'common/barrels/rx';
import * as path from 'shared/path';

import { Control } from 'runtime/controls/control';
import { ControlArgs } from 'runtime/controls/controlargs';
import { registerBinding } from 'runtime/bindingengine';
import { ViewInfoRequested } from 'runtime/events/viewinforequested';
import * as rxui from 'common/rxui/core';

import 'runtime/styles/controls/imagecontrol.less';
import { undefinedNullOrEmpty } from 'common/functions/string';

export class ImageControl extends Control {
    private $img: JQuery;
    private $inner: JQuery;

    private url: BehaviorSubject<string>;
    private initialImage: any;

    constructor(args: ControlArgs) {
        super(args);

        this.methods.register(this.config.elementName, this);

        this.$element.addClass('control-container imagecontrol');

        var $outer = $('<div />').appendTo(this.$element);
        this.$inner= $('<div />').appendTo($outer);

        const fileContent = this.config['content.FileContent'];
        const isBase64 = (x: string) => !!x && x.indexOf('.') === -1;
        this.initialImage = this.config['content.Uri'] || (isBase64(fileContent) ? ('data:image/jpeg;base64,' + fileContent) : fileContent);
        this.url = new BehaviorSubject<string>(this.initialImage);

        this.applyTooltip(this.$img);
        this.subscriptions = disposableSubscription(
            rxui.redrawRequired(Observable.of({}), this.container.activatedStream, this.visibilityStream, this.stretches() ? this.container.resizeStream() : Observable.never()).subscribe(() => this.update()),
            this.processBindings(this.config)
        );

        this.initialize();
    }

    dispose() {
        super.dispose();
    }

    'content.Uri'(value: string) {
        this.url.next(undefinedNullOrEmpty(value) ? this.initialImage : value);
    }

    private update() {
        if (this.$img)
            this.applyDimensions();
        else
            this.createImage();
    }

    private createImage() {
        this.$img = $('<img>')
            .conditionalCss(this.config['content.Cursor'], 'cursor')
            .on('load', () => this.applyDimensions())
            .on('error', () => this.$img.hide())
            .hide()
            .appendTo(this.$inner);

        var subscriptions = disposableSubscription(
            this.url.distinctUntilChanged().filter(x => x !== null).subscribe(x => this.$img.attr('src', x)),
            rxui.from(this.$img, 'click').filter(() => this.derivedEnabledState() !== false).subscribe(() => this.click())
        );

        this.$img.on('remove', () => subscriptions.dispose());
    }

    private applyDimensions() {
        var img = <any>this.$img.get(0);

        var containerAspect = this.$element.width() / this.$element.height();
        var imageAspect = 'naturalWidth' in img
            ? img.naturalWidth / img.naturalHeight
            : this.$img.width() / this.$img.height();

        this.$img.width(imageAspect >= containerAspect ? this.$element.width() : this.$element.height() * imageAspect)
                    .height(imageAspect < containerAspect ? this.$element.height() : this.$element.width() / imageAspect);

        this.$img.show();
    }

    click() {
        this.$element.triggerHandler('events.Clicked');
    }

    focus() { }
}

registerBinding('imagecontrol', ImageControl);